import type { Locale } from "@planerius/contracts"
import type { CabinetDeviceSessionView } from "@planerius/contracts/cabinet-auth"

import { apiRequest } from "./http"

/**
 * Профиль и безопасность (1-Э1.10, 5-М7): свои входы и свой пароль.
 *
 * Всё здесь — про СВОЮ учётную запись и работает без выбранного салона (сервер:
 * @AllowTenantless): управлять своими входами человек вправе и тогда, когда салона у него
 * уже нет, — например, закрыть потерянный телефон после увольнения.
 */

export function listMySessions(signal?: AbortSignal): Promise<CabinetDeviceSessionView[]> {
  return apiRequest("/cabinet/auth/sessions", { signal })
}

export function revokeMySession(sessionId: string): Promise<void> {
  return apiRequest("/cabinet/auth/sessions/revoke", { method: "POST", body: { sessionId } })
}

/** Все входы, кроме этого. Текущий сервер не трогает. */
export function revokeMyOtherSessions(): Promise<void> {
  return apiRequest("/cabinet/auth/sessions/revoke-others", { method: "POST" })
}

/**
 * Смена языка интерфейса.
 *
 * Ответа нет намеренно (204): профиль кабинет перечитывает сам, тем же путём, что после
 * смены пароля. Второй источник правды о том, кто я и что мне можно, здесь не нужен.
 */
export function changeMyLocale(locale: Locale): Promise<void> {
  return apiRequest("/cabinet/auth/locale", { method: "POST", body: { locale } })
}

/**
 * Смена пароля. Текущий пароль обязателен и внутри живой сессии: захваченная вкладка
 * не должна уметь сменить пароль. Сервер закрывает все остальные входы, этот остаётся.
 */
export function changeMyPassword(currentPassword: string, newPassword: string): Promise<void> {
  return apiRequest("/cabinet/auth/password", { method: "POST", body: { currentPassword, newPassword } })
}
